/*
 * File: store.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 30 Sep 2020 4:54:42 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { AnyAction, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import { appSlice } from './app/app-slice';
import { poReceiptsSlice } from './poReceipts/po-receipts-slice';
import { selectedLegalEntitySlice } from './selectedLegalEntity/selectedLegalEntitySlice';
import { userApi } from './services/cookieMonster';
import { freddyCadabbyApi } from './services/freddyCadabby';
import { grannyBirdApi } from './services/grannyBird';
import { binParams } from './services/grannyBird/binParams';
import { grannyBirdInfo } from './services/grannyBird/grannyBirdApi';
import { grannyBirdParams } from './services/grannyBird/poReceiptParams';
import { maggieCadabbyApi, maggieCadabbyParams } from './services/maggieCadabby';

const store = configureStore({
  reducer: {
    [appSlice.name]: appSlice.reducer,
    [poReceiptsSlice.name]: poReceiptsSlice.reducer,
    [selectedLegalEntitySlice.name]: selectedLegalEntitySlice.reducer,
    // GRANNY BIRD
    [grannyBirdApi.reducerPath]: grannyBirdApi.reducer,
    [grannyBirdInfo.reducerPath]: grannyBirdInfo.reducer,
    [grannyBirdParams.name]: grannyBirdParams.reducer,
    [binParams.name]: binParams.reducer,
    // MAGGIE CADABBY
    [maggieCadabbyApi.reducerPath]: maggieCadabbyApi.reducer,
    [maggieCadabbyParams.name]: maggieCadabbyParams.reducer,
    // FREDDY CADABBY
    [freddyCadabbyApi.reducerPath]: freddyCadabbyApi.reducer,
    // COOKIE MONSTER
    [userApi.reducerPath]: userApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(grannyBirdApi.middleware).concat(maggieCadabbyApi.middleware).concat(freddyCadabbyApi.middleware).concat(userApi.middleware).concat(grannyBirdInfo.middleware)
});

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./rootReducer', () => {
//     // eslint-disable-next-line @typescript-eslint/no-var-requires
//     const newRootReducer = require('./rootReducer').default;

//     store.replaceReducer(newRootReducer);
//   });
// }

export type ReduxState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export type ThunkAppDispatch = ThunkDispatch<ReduxState, void, AnyAction>;

export default store;
